import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const imgSrc = (p) => {
  if (!p) return "https://images.pexels.com/photos/18223728/pexels-photo-18223728.jpeg?auto=compress&cs=tinysrgb&h=650&w=940";
  return p.startsWith("http") ? p : `${API}/files/${p}`;
};

export const money = (v, cur = "BRL") =>
  new Intl.NumberFormat(cur === "BRL" ? "pt-BR" : "pt-PT", { style: "currency", currency: cur }).format(v || 0);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const RARITY = {
  comum: { label: "Comum", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  raro: { label: "Raro", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  epico: { label: "Épico", cls: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  lendario: { label: "Lendário", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
};

export const STATUS = {
  pendente: { label: "Aguardando pagamento", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  em_analise: { label: "Comprovativo em análise", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  pago: { label: "Pago", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  entregue: { label: "Entregue", cls: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  cancelado: { label: "Cancelado", cls: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
};
